function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { VideoTrackMeta, AudioTrackMeta, XGDataView, FlvTag, VideoSample } from 'xgplayer-helper-models';
import { avc, hevc } from 'xgplayer-helper-codec';
import AMFParser from './amf-parser';
import EventEmitter from 'eventemitter3';
var SpsParser = avc.SpsParser,
    NalUnit = avc.NalUnit;
var SpsParserHEVC = hevc.SpsParserHEVC,
    NalUnitHEVC = hevc.NalUnitHEVC;
var HEVC_KEY_NALS = [19, 20, 21];
var AVC_KEY_NALS = [5];

var FlvDemuxer = /*#__PURE__*/function (_EventEmitter) {
  _inherits(FlvDemuxer, _EventEmitter);

  var _super = _createSuper(FlvDemuxer);

  function FlvDemuxer() {
    var _this;

    _classCallCheck(this, FlvDemuxer);

    _this = _super.call(this);
    /** @type {boolean} */

    _this._headerParsed = false;
    /** @type {number} */

    _this._gopId = 0;
    _this._videoRecentMetadata = null;
    /** @type {*}  */

    _this._onMetaData = null;
    _this._audioMetaParsed = false;
    _this._userAgent = typeof window === 'undefined' ? '' : window.navigator.userAgent.toLowerCase() || '';
    return _this;
  }
  /**
   *
   * @return {{FILE_HEADER_PARSED: string, AUDIO_META_PARSED: string, SCRIPT_TAG_PARSED: string, AUDIO_SAMPLE_PARSED: string, VIDEO_META_PARSED: string, VIDEO_SAMPLE_PARSED: string, VIDEO_SEI_PARSED: string}}
   * @constructor
   */


  _createClass(FlvDemuxer, [{
    key: "foundAudioMetaFromScriptTag",
    get: function get() {
      var _this$_onMetaData, _this$_onMetaData2;

      return ((_this$_onMetaData = this._onMetaData) === null || _this$_onMetaData === void 0 ? void 0 : _this$_onMetaData.audiosamplerate) && ((_this$_onMetaData2 = this._onMetaData) === null || _this$_onMetaData2 === void 0 ? void 0 : _this$_onMetaData2.audiochannels);
    }
  }, {
    key: "demux",
    value: function demux(buffer) {
      if (!this._headerParsed) {
        if (buffer.length < 13) {
          return;
        }

        var header = buffer.shift(13);
        this.parseFlvHeader(header);
        this.demux(buffer); // recursive invoke
      } else {
        if (buffer.length < 11) {
          return;
        }

        var flvTag;
        var loopMax = 10000; // avoid Infinite loop

        do {
          flvTag = this._parseFlvTag(buffer);
        } while (flvTag && loopMax-- > 0);
      }
    }
  }, {
    key: "parseFlvHeader",
    value: function parseFlvHeader(header) {
      if (!FlvDemuxer.isFlvFile(header)) {
        throw new Error("invalid flv file,".concat(header.join(',')));
      } else {
        this._headerParsed = true;
        var hasAudio = header[4] >>> 2 === 1;
        var hasVideo = (header[4] & 1) === 1;
        this.emit(FlvDemuxer.EVENTS.FILE_HEADER_PARSED, {
          hasVideo: hasVideo,
          hasAudio: hasAudio
        });
      }
    }
    /**
     * Package the data as the following data structure
     * {
     *    data: Uint8Array. the Stream data.
     *    info: The first byte info of the Tag.
     *    tagType: 8、9、18
     *    timeStamp: the timestemp
     * }
     */

  }, {
    key: "_parseFlvTag",
    value: function _parseFlvTag(buffer) {
      var tagSize = buffer.toInt(1, 3);

      if (buffer.length < 11 + tagSize + 4) {
        // no enough data for tag parsing
        return null;
      }

      var flvTag = this._parseFlvTagHeader(buffer);

      if (flvTag) {
        this._processTagData(flvTag, buffer);

        if (!this._datasizeValidator(flvTag.datasize, buffer)) {
          throw new Error('TAG length error at ' + flvTag.datasize);
        }
      }

      return flvTag;
    }
    /**
     * Parse the 11 byte tag Header
     */

  }, {
    key: "_parseFlvTagHeader",
    value: function _parseFlvTagHeader(buffer) {
      var offset = 0;
      var flvTag = new FlvTag();
      var tagType = buffer.toInt(offset, 1);
      offset += 1; // 2 bit FMS reserved, 1 bit filtered, 5 bit tag type

      flvTag.filtered = (tagType & 32) >>> 5;
      flvTag.tagType = tagType & 31; // 3 Byte datasize

      flvTag.datasize = buffer.toInt(offset, 3);
      offset += 3;

      if (flvTag.tagType !== 8 && flvTag.tagType !== 9 && flvTag.tagType !== 11 && flvTag.tagType !== 18) {
        if (buffer && buffer.length > 0) {
          buffer.shift(1);
        }

        throw new Error('tagType ' + flvTag.tagType);
      }

      if (buffer.length < flvTag.datasize + 15) {
        return null;
      } // read the data.


      buffer.shift(4); // 3 Byte timestamp

      var timestamp = buffer.toInt(0, 3);
      buffer.shift(3); // 1 Byte timestampExt

      var timestampExt = buffer.shift(1)[0];

      if (timestampExt > 0) {
        timestamp += timestampExt * 0x1000000;
      }

      flvTag.dts = timestamp; // streamId

      buffer.shift(3); // 4 + 3 + 3 + 1 = 11 字节 TagHeader

      return flvTag;
    }
  }, {
    key: "_processTagData",
    value: function _processTagData(flvTag, buffer) {
      switch (flvTag.tagType) {
        case 18:
          this._parseScriptData(flvTag, buffer);

          break;

        case 8:
          this._parseAudioTag(flvTag, buffer);

          break;

        case 9:
          this._parseVideoData(flvTag, buffer);

          break;

        case 11:
          // for some CDN that did not process the currect RTMP messages
          buffer.shift(3);
          break;

        default:
          buffer.shift(1);
      }
    }
    /**
     * parse flv script data
     * @param flvTag
     * @private
     */

  }, {
    key: "_parseScriptData",
    value: function _parseScriptData(flvTag, buffer) {
      flvTag.data = buffer.shift(flvTag.datasize);
      var info = new AMFParser().resolve(flvTag.data, flvTag.data.length);
      this._onMetaData = info ? info.onMetaData : undefined;
      this.emit(FlvDemuxer.EVENTS.SCRIPT_TAG_PARSED, this._onMetaData);
    } // ISO中定义的AudioSpecificConfig
    // *  audioObjectType    5bit
    // *  samplingFrquecyIndex   4bit
    // *  if(samplingFrquencyIndex === 0xf)
    // *     samplingFrequency   24bit
    // *  channelConfiguration   4bit |01111000|

  }, {
    key: "_aacSequenceHeaderParser",
    value: function _aacSequenceHeaderParser(data) {
      var ret = {};
      ret.hasSpecificConfig = true;
      ret.objectType = data[1] >>> 3;
      ret.originObjectType = ret.objectType;
      ret.sampleRateIndex = (data[1] & 7) << 1 | data[2] >>> 7;
      ret.audiosamplerate = this._switchAudioSampleRate(ret.sampleRateIndex);
      ret.channelCount = (data[2] & 120) >>> 3;
      ret.frameLength = (data[2] & 4) >>> 2;
      ret.dependsOnCoreCoder = (data[2] & 2) >>> 1;
      ret.extensionFlagIndex = data[2] & 1;
      var extensionSamplingIndex;
      var config;
      var samplingIndex = ret.sampleRateIndex;

      if (this._userAgent.indexOf('firefox') !== -1) {
        // 火狐下 HE-AACv2编码方式 采样率是22050时候也要使用 LC-AAC
        // firefox: use SBR (HE-AAC) if freq less than 24kHz
        if (ret.sampleRateIndex >= 8) {
          ret.objectType = 5;
          config = new Array(4);
          extensionSamplingIndex = samplingIndex - 3;
        } else {
          // use LC-AAC
          ret.objectType = 2;
          config = new Array(2);
          extensionSamplingIndex = samplingIndex;
        }
      } else if (this._userAgent.indexOf('android') !== -1 || this._userAgent.indexOf('iphone') !== -1) {
        // android: always use LC-AAC
        ret.objectType = 2;
        config = new Array(2);
        extensionSamplingIndex = samplingIndex;
      } else {
        // for other browsers, e.g. chrome...
        // Always use HE-AAC to make it easier to switch aac codec profile
        ret.objectType = 5;
        extensionSamplingIndex = ret.sampleRateIndex;
        config = new Array(4);

        if (ret.sampleRateIndex >= 6) {
          extensionSamplingIndex = ret.sampleRateIndex - 3;
        } else if (ret.channelCount === 1) {
          // Mono channel
          ret.objectType = 2;
          config = new Array(2);
          extensionSamplingIndex = ret.sampleRateIndex;
        }
      }

      ret.codec = "mp4a.40.".concat(ret.objectType);
      config[0] = ret.objectType << 3;
      config[0] |= (ret.sampleRateIndex & 0x0F) >>> 1;
      config[1] = (ret.sampleRateIndex & 0x0F) << 7;
      config[1] |= (ret.channelCount & 0x0F) << 3;

      if (ret.objectType === 5) {
        config[1] |= (extensionSamplingIndex & 0x0F) >>> 1;
        config[2] = (extensionSamplingIndex & 0x01) << 7; // extended audio object type: force to 2 (LC-AAC)

        config[2] |= 2 << 2;
        config[3] = 0;
      }

      ret.config = config;
      return ret;
    } //   TagType == 8时
    //  *                     header.filter == 1  header.filter == 1
    //  *    | AudioTagHeader | EncryptionHeader? | FilterParams? | AUDIODATA |
    //  *
    //  * AudioTagHeader结构 (1或2字节):
    //  * SoundFormat : bit1-4 表示音频格式。 0:行内pcm数据，平台字节序 3:行内pcm,小端序 10:aac格式
    //  * SoundRate : bit5-6  采样率 0=5.5kHz 1=11kHz 2=22kHz  3=44kHz
    //  * SoundSize : 采样大小 0=8bit 1采样 1=16bit 1采样
    //  * SoundType : 声道类型 0=单声道 1=立体声
    //  * AACPacketType : 1字节 如果soundFormat==10 及aac编码格式,则存在这个字节
    //  *                      0=aac 序列header , 1=aac元数据

  }, {
    key: "_parseAudioTag",
    value: function _parseAudioTag(tag, buffer) {
      var meta = new AudioTrackMeta();
      var info = buffer.shift(1)[0];
      tag.data = buffer.shift(tag.datasize - 1);
      var format = (info & 240) >>> 4;

      if (format !== 10) {
        throw new Error("invalid audio format: ".concat(format));
      }

      if (format === 10) {
        meta.sampleRate = this._switchAudioSamplingFrequency(info);
        meta.sampleRateIndex = (info & 12) >>> 2;
        meta.frameLenth = (info & 2) >>> 1;
        meta.channelCount = info & 1;
        meta.refSampleDuration = Math.floor(1024 / meta.audioSampleRate * meta.timescale);
      }

      var audioSampleRate = meta.audioSampleRate;
      var audioSampleRateIndex = meta.sampleRateIndex;
      var refSampleDuration = meta.refSampleDuration; // AACPacketType

      if (tag.data[0] === 0) {
        // AAC Sequence Header
        var aacHeader = this._aacSequenceHeaderParser(tag.data);

        audioSampleRate = aacHeader.audiosamplerate || meta.audioSampleRate;
        audioSampleRateIndex = aacHeader.sampleRateIndex || meta.sampleRateIndex;
        refSampleDuration = Math.floor(1024 / audioSampleRate * meta.timescale);
        meta.channelCount = aacHeader.channelCount;
        meta.sampleRate = audioSampleRate;
        meta.sampleRateIndex = audioSampleRateIndex;
        meta.refSampleDuration = refSampleDuration;
        meta.duration = this._onMetaData ? this._onMetaData.duration * meta.timescale : 0;
        meta.config = aacHeader.config;
        meta.objectType = aacHeader.objectType;
        meta.originObjectType = aacHeader.originObjectType;
        this.emit(FlvDemuxer.EVENTS.AUDIO_META_PARSED, meta);
        this._audioMetaParsed = true;
      } else {
        if (!this._audioMetaParsed && !this.foundAudioMetaFromScriptTag) {
          throw new Error('flv stream without audio metadata detected');
        }

        tag.data = tag.data.slice(1, tag.data.length);
        this.emit(FlvDemuxer.EVENTS.AUDIO_SAMPLE_PARSED, tag);
      }
    } // parse hevc/avc video data
    // *  TagType == 9时
    // *                      filter == 1         filter == 1
    // *    | VideoTagHeader | EncryptionHeader? | FilterParams? | VideoDATA |
    // *
    // * VideoTagHeader结构(AVC格式 5字节):
    // * FrameType : bit 1-4  1=keyFrame  2=inter frame
    // * CodecId : bit 5-8  编码器信息  7=AVC
    // * AvcPacketType :  1字节  codecId==7时存在   0=avc序列header 1=avc nalU 2=avc end of sequence
    // * CompositionTime  : 3字节 codecId==7时存在  取值 0 或者 具体值 单位ms

  }, {
    key: "_parseVideoData",
    value: function _parseVideoData(flvTag, buffer) {
      // header
      var header = buffer.shift(1)[0];
      var vSample = new VideoSample(flvTag);
      var frameType = (header & 0xf0) >>> 4;
      vSample.isKeyframe = frameType === 1;
      var codecID = header & 0x0f; // hevc和avc的header解析方式一样

      flvTag.avcPacketType = buffer.shift(1)[0];
      vSample.cts = buffer.toInt(0, 3);
      vSample.cts = vSample.cts << 8 >> 8;
      buffer.shift(3); // 12 for hevc, 7 for avc

      if (codecID === 7 || codecID === 12) {
        var _hevc = codecID === 12;

        var data = buffer.shift(flvTag.datasize - 5); // 减5字节header信息

        if (data[4] === 0 && data[5] === 0 && data[6] === 0 && data[7] === 1) {
          var avcclength = 0;

          for (var i = 0; i < 4; i++) {
            avcclength = avcclength * 256 + data[i];
          }

          avcclength -= 4;
          data = data.slice(4, data.length);
          data[3] = avcclength % 256;
          avcclength = (avcclength - data[3]) / 256;
          data[2] = avcclength % 256;
          avcclength = (avcclength - data[2]) / 256;
          data[1] = avcclength % 256;
          data[0] = (avcclength - data[1]) / 256;
        }

        if (!data.length) return;
        vSample.data = data;
        var videoMeta;

        if (flvTag.avcPacketType === 0) {
          if (_hevc) {
            videoMeta = this._hevcSequenceHeaderParser(data);
          } else {
            videoMeta = this._avcSequenceHeaderParser(data);
          }

          videoMeta.codecID = codecID;
          this._videoRecentMetadata = videoMeta;
          this.emit(FlvDemuxer.EVENTS.VIDEO_META_PARSED, videoMeta);
        } else {
          var dv = new XGDataView(data.buffer);
          var nals = _hevc ? NalUnitHEVC.getHvccNals(dv) : NalUnit.getAvccNals(dv);
          var keyTypes = _hevc ? HEVC_KEY_NALS : AVC_KEY_NALS;
          var hasSps = false;

          for (var _i = 0; _i < nals.length; _i++) {
            var unit = nals[_i];
            _hevc ? NalUnitHEVC.analyseNal(unit) : NalUnit.analyseNal(unit);

            if (unit.sps) {
              hasSps = true;
            }

            if (unit.sei) {
              this.emit(FlvDemuxer.EVENTS.VIDEO_SEI_PARSED, Object.assign(unit.sei, {
                dts: flvTag.dts
              }));
            }

            if (keyTypes.indexOf(unit.type) > -1) {
              vSample.firstInGop = true;
              this._gopId++;
            }
          } // 对解析到sequence header，紧跟其后的关键帧Tag中没有sps、pps信息的。在关键帧Nal前补上sps、pps


          if (this._videoRecentMetadata && vSample.firstInGop && !hasSps) {
            var _this$_videoRecentMet = this._videoRecentMetadata,
                vps = _this$_videoRecentMet.vps,
                sps = _this$_videoRecentMet.sps,
                pps = _this$_videoRecentMet.pps;
            var nalChunks = [vps ? [0, 0, vps.length >> 8, vps.length % 256] : 0, vps, [0, 0, sps.length >> 8, sps.length % 256], sps, [0, 0, pps.length >> 8, pps.length % 256], pps, vSample.data].filter(Boolean);
            var newSize = nalChunks.reduce(function (all, c) {
              return all += c.length;
            }, 0);
            var b = new Uint8Array(newSize);
            var offset = 0;
            nalChunks.forEach(function (x) {
              b.set(x, offset);
              offset += x.length;
            });
            this._videoRecentMetadata = null;
            vSample.data = b;
          }

          vSample.gopId = this._gopId;
          vSample.nals = nals;
          this.emit(FlvDemuxer.EVENTS.VIDEO_SAMPLE_PARSED, vSample);
        }
      } else {
        throw new Error("video codeid is ".concat(codecID));
      }
    }
    /**
     * parse avc metadata
     *  configurationVerison = 1  uint(8)
     *  avcProfileIndication      uint(8)
     *  profile_compatibility     uint(8)
     *  avcLevelIndication        uint(8)
     *  reserved   `111111`       bit(6)
     *  lengthSizeMinusOne        uint(2)
     *  reserved   `111`          bit(3)
     *  numOfSPS                  uint(5)
     *  for(numOfSPS)
     *    spsLength               uint(16)
     *    spsNALUnit              spsLength个字节
     *  numOfPPS                  uint(8)
     *  for(numOfPPS)
     *     ppsLength              uint(16)
     *     ppsNALUnit             ppsLength个字节
     */

  }, {
    key: "_avcSequenceHeaderParser",
    value: function _avcSequenceHeaderParser(data) {
      var _this$_onMetaData3;

      var offset = 0;
      var meta = new VideoTrackMeta();
      meta.configurationVersion = data[0];
      meta.avcProfileIndication = data[1];
      meta.profileCompatibility = data[2];
      meta.avcLevelIndication = data[3] / 10;
      meta.nalUnitLength = (data[4] & 0x03) + 1;
      var numOfSps = data[5] & 0x1f;
      offset = 6;
      var config = {}; // parse SPS

      for (var i = 0; i < numOfSps; i++) {
        var size = data[offset] * 255 + data[offset + 1];
        offset += 2;
        var sps = new Uint8Array(size);

        for (var j = 0; j < size; j++) {
          sps[j] = data[offset + j];
        } // codec string


        var codecString = 'avc1.';

        for (var _j = 1; _j < 4; _j++) {
          var h = sps[_j].toString(16);

          if (h.length < 2) {
            h = '0' + h;
          }

          codecString += h;
        }

        meta.codec = codecString;
        offset += size;
        meta.sps = sps;
        config = SpsParser.parseSPS(sps);
      }

      var numOfPps = data[offset];
      offset++;

      for (var _i2 = 0; _i2 < numOfPps; _i2++) {
        var _size = data[offset] * 255 + data[offset + 1];

        offset += 2;
        var pps = new Uint8Array(_size);

        for (var _j2 = 0; _j2 < _size; _j2++) {
          pps[_j2] = data[offset + _j2];
        }

        offset += _size;
        meta.pps = pps;
      }

      Object.assign(meta, SpsParser.toVideoMeta(config));
      meta.duration = ((_this$_onMetaData3 = this._onMetaData) === null || _this$_onMetaData3 === void 0 ? void 0 : _this$_onMetaData3.duration) * meta.timescale;
      meta.avcc = new Uint8Array(data.length);
      meta.avcc.set(data);
      meta.streamType = 0x1b;
      return meta;
    }
    /**
     * parse hevc metadata
     *  configurationVerison = 1  uint(8)
     *  generalProfileSpace       uint(2)
     *  generalTierFlag           uint(1)
     *  generalProfileIdc         uint(5)
     *  generalProfileCompatibilityFlags uint(32)
     *  generalConstraintIndicatorFlags  uint(48)
     *  generalLevelIdc           uint(8)
     *  complete_representation   bit(1)
     *  reserved   `111`          bit(3)
     *  segmentationIdc           uint(12)
     *  reserved `111111`         bit(6)
     *  parallelismType           uint(2)
     *  reserved `111111`         bit(6)
     *  chromaFormat              uint(2)
     *  reserved `11111`          bit(5)
     *  bitDepthLumaMinus8        uint(3)
     *  reserved `11111`          bit(5)
     *  bitDepthChromaMinus8      uint(3)
     *  avgFrameRate              bit(16)
     *  constantFrameRate         bit(2)
     *  numTemporalLayers         bit(3)
     *  temporalIdNested          bit(1)
     *  lengthSizeMinusOne        uint(2)
     *  numOfArrays               uint(8)
     *  for(numOfArrays)
     *    arrayCompleteness       bit(1)
     *    reserved                uint(1)
     *    nalUnitType             uint(16)
     *    numNals                 uint(16)
     *    for(numNals)
     *       nalUintLength        uint(16)
     *       nalUint              bit(8 * nalUintLength)
     */

  }, {
    key: "_hevcSequenceHeaderParser",
    value: function _hevcSequenceHeaderParser(data) {
      var meta = new VideoTrackMeta();
      var offset = 0;
      meta.configurationVersion = data[0];
      meta.hevcProfileSpace = (data[1] & 0xc0) >>> 6;
      meta.hevcTierFlag = (data[1] & 0x20) >>> 5;
      meta.hevcProfileIdc = data[1] & 0x1f;
      meta.hevcProfileCompatibilityFlags = [data[2], data[3], data[4], data[5]];
      meta.hevcConstraintIndicatorFlags = [data[6], data[7], data[8], data[9], data[10], data[11]];
      meta.hevcLevelIdc = data[12];
      meta.minSpatialSegmentationIdc = data[13] & 0x0f + data[14] << 4;
      meta.parallelismType = data[15] & 0x03;
      meta.chromaFormat = data[16] & 0x03;
      meta.bitDepthLumaMinus8 = data[17] & 0x07;
      meta.bitDepthChromaMinus8 = data[18] & 0x07;
      meta.avgFrameRate = data[19] * 256 + data[20];
      meta.constantFrameRate = (data[21] & 0xc0) >>> 6;
      meta.numTemporalLayers = (data[21] & 0x38) >>> 3;
      meta.temporalIdNested = (data[21] & 0x04) >>> 2;
      meta.lengthSizeMinusOne = data[21] & 0x03;
      var numOfArrays = data[22];
      offset = 23;
      var config = {};
      var nalUnitType = 0;
      var numNalus = 0;
      var nalUnitSize = 0;
      var hasVPS = false;
      var hasSPS = false;
      var hasPPS = false;
      var vps, sps, pps;

      for (var i = 0; i < numOfArrays; i++) {
        nalUnitType = data[offset] & 0x3f;
        numNalus = data[offset + 1] * 256 + data[offset + 2];
        offset += 3;

        for (var j = 0; j < numNalus; j++) {
          nalUnitSize = data[offset] * 256 + data[offset + 1];

          switch (nalUnitType) {
            case 32:
              if (!hasVPS) {
                hasVPS = true;
                vps = data.slice(offset + 2, offset + 2 + nalUnitSize);
                meta.vps = SpsParserHEVC._ebsp2rbsp(vps);
                meta.rawVps = vps;
              }

              break;

            case 33:
              if (!hasSPS) {
                hasSPS = true;
                sps = data.slice(offset + 2, offset + 2 + nalUnitSize);
                meta.sps = SpsParserHEVC._ebsp2rbsp(sps);
                meta.rawSps = sps;
                meta.codec = 'hev1.1.6.L93.B0';
                config = SpsParserHEVC.parseSPS(sps);
              }

              break;

            case 34:
              if (!hasPPS) {
                hasPPS = true;
                pps = data.slice(offset + 2, offset + 2 + nalUnitSize);
                meta.pps = SpsParserHEVC._ebsp2rbsp(pps);
                meta.rawPps = pps;
              }

              break;

            case 39:
              // PREFIX_SEI
              break;

            case 40:
              // SUFFIX_SEI
              break;

            default:
              break;
          }

          offset += 2 + nalUnitSize;
        }
      }

      Object.assign(meta, SpsParserHEVC.toVideoMeta(config));
      meta.streamType = 0x24;
      return meta;
    }
    /**
     * choose audio sample rate
     * @param samplingFrequencyIndex
     * @returns {number}
     * @private
     */

  }, {
    key: "_switchAudioSampleRate",
    value: function _switchAudioSampleRate(samplingFrequencyIndex) {
      var samplingFrequencyList = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
      return samplingFrequencyList[samplingFrequencyIndex];
    }
    /**
     * choose audio sampling frequence
     * @param info
     * @returns {number}
     * @private
     */

  }, {
    key: "_switchAudioSamplingFrequency",
    value: function _switchAudioSamplingFrequency(info) {
      var samplingFrequencyIndex = (info & 12) >>> 2;
      var samplingFrequencyList = [5500, 11025, 22050, 44100, 48000];
      return samplingFrequencyList[samplingFrequencyIndex];
    }
    /**
     * choose audio channel count
     * @param info
     * @returns {number}
     * @private
     */

  }, {
    key: "_switchAudioChannel",
    value: function _switchAudioChannel(info) {
      var sampleTrackNumIndex = info & 1;
      var sampleTrackNumList = [1, 2];
      return sampleTrackNumList[sampleTrackNumIndex];
    }
    /**
     * check datasize is valid use 4 Byte after current tag
     * @param datasize
     * @returns {boolean}
     * @private
     */

  }, {
    key: "_datasizeValidator",
    value: function _datasizeValidator(datasize, buffer) {
      var datasizeConfirm = buffer.toInt(0, 4);
      buffer.shift(4);
      return datasizeConfirm === datasize + 11;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(FlvDemuxer.prototype), "removeAllListeners", this).call(this);
    }
  }], [{
    key: "EVENTS",
    get: function get() {
      return {
        FILE_HEADER_PARSED: 'FILE_HEADER_PARSED',
        SCRIPT_TAG_PARSED: 'SCRIPT_TAG_PARSED',
        AUDIO_META_PARSED: 'AUDIO_META_PARSED',
        VIDEO_META_PARSED: 'VIDEO_META_PARSED',
        VIDEO_SAMPLE_PARSED: 'VIDEO_SAMPLE_PARSED',
        AUDIO_SAMPLE_PARSED: 'AUDIO_SAMPLE_PARSED',
        VIDEO_SEI_PARSED: 'VIDEO_SEI_PARSED'
      };
    }
    /**
     * if the flv head is valid
     * @param data
     * @returns {boolean}
     */

  }, {
    key: "isFlvFile",
    value: function isFlvFile(data) {
      return !(data[0] !== 0x46 || data[1] !== 0x4C || data[2] !== 0x56 || data[3] !== 0x01);
    }
    /**
     * If the stream has audio or video.
     * @param {number} streamFlag - Data from the stream which is define whether the audio / video track is exist.
     */

  }, {
    key: "getPlayType",
    value: function getPlayType(streamFlag) {
      var result = {
        hasVideo: false,
        hasAudio: false
      };

      if (streamFlag & 0x01 > 0) {
        result.hasVideo = true;
      }

      if (streamFlag & 0x04 > 0) {
        result.hasAudio = true;
      }

      return result;
    }
  }]);

  return FlvDemuxer;
}(EventEmitter);

export default FlvDemuxer;